module.exports = __webpack_public_path__ + "img/upsell-options.c48fbc90.svg";